module.exports = __webpack_public_path__ + "static/horno-prod-91f9612ae8c372fe1051a8e0d591b4a4.png";